import { render } from "./UnlockTiktok.vue?vue&type=template&id=1c475e18"
import script from "./UnlockTiktok.vue?vue&type=script&lang=js"
export * from "./UnlockTiktok.vue?vue&type=script&lang=js"

import "./UnlockTiktok.vue?vue&type=style&index=0&id=1c475e18&lang=css"

import exportComponent from "/var/www/ab-front-library/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__